module.exports = __webpack_public_path__ + "img/icon-whatsapp-fill.4476d882.svg";